<form class="popupForm" style="min-height: 200px;">
  <div class="common" mat-dialog fxLayout="column" fxLayoutAlign="space-between" style="min-height: inherit;">
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between end">
      <ng-container *ngIf="payload['isCanceling']">Cancel confirmation</ng-container>
      <ng-container *ngIf="!payload['isCanceling']">Delete confirmation</ng-container>
      <button mat-icon-button mat-dialog-close id="close-upload" alt="close" title="close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="when-fx-layout-broke" style="display: flex !important;">
      <div *ngIf="payload['isCanceling']">
        Are you sure you want to cancel selected item ?
      </div>
      <div *ngIf="!payload['isCanceling']">
        Are you sure you want to delete selected item ?
      </div>
      <!--<div *ngIf="target.length > 1; else singleDelete">-->
        <!--Are you sure you want to delete {{target.length}} selected items ?-->
      <!--</div>-->
      <!--<ng-template #singleDelete>-->
        <!--<div>-->
          <!--Are you sure you want to delete-->
          <!--<span class="inlineEllipsis">{{target[0].name}}</span> {{target[0].isDirectory ? 'directory': 'file' }} ?-->
        <!--</div>-->
      <!--</ng-template>-->
    </mat-dialog-content>
    <div fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="10px">
      <button mat-button class="cancel widerButton font16" (click)="onNoClick()">
        {{'close'|GetLabelPipe}}
      </button>
      <button *ngIf="payload['isCanceling']"
              type="submit" class="widerButton font16" mat-raised-button color="accent" (click)="handleSubmit()">
        {{'cancel2'|GetLabelPipe}}
      </button>
      <button *ngIf="!payload['isCanceling']"
              type="submit" class="widerButton font16" mat-raised-button color="accent" (click)="handleSubmit()">
        {{'delete'|GetLabelPipe}}
      </button>
    </div>
  </div>
</form>
